import { Illustration, Text } from "@clipboard-health/ui-components";
import { isDefined } from "@clipboard-health/util-ts";
import { CardContent, Stack } from "@mui/material";
import { Button } from "@src/appV2/redesign/components/Button";
import { type ChartingCredential } from "@src/appV2/Shifts/Shift/useGetChartingCredentials";

import { ShiftDetailsInnerCard } from "../InnerCard";

export interface ChartingRequiredCardContentProps {
  chartingCredentials?: ChartingCredential;
  onRequestLogin?: () => void;
  onSaveLogin?: () => void;
  onMyChartingLogin?: () => void;
}

export function ChartingRequiredCardContent(props: ChartingRequiredCardContentProps) {
  const { chartingCredentials, onRequestLogin, onSaveLogin, onMyChartingLogin } = props;

  const hasCredentials =
    isDefined(chartingCredentials) &&
    isDefined(chartingCredentials.username) &&
    isDefined(chartingCredentials.password);

  const getMessage = () => {
    if (hasCredentials) {
      return "Use your charting login to set up the EHR at the start of the shift";
    }

    return "Ask the facility for your login if they have not provided it yet";
  };

  const getActionButton = () => {
    if (hasCredentials) {
      return (
        <Button fullWidth size="medium" onClick={onMyChartingLogin}>
          My charting login
        </Button>
      );
    }

    return (
      <Stack spacing={2}>
        <Button fullWidth size="medium" onClick={onRequestLogin}>
          Request my login
        </Button>
        <Button fullWidth variant="outlined" size="medium" onClick={onSaveLogin}>
          Save my login
        </Button>
      </Stack>
    );
  };

  return (
    <ShiftDetailsInnerCard footer={getActionButton()}>
      <CardContent>
        <Stack spacing={4} alignItems="center" sx={{ paddingX: 4, paddingY: 4 }}>
          <Illustration type="quiz-required" />

          <Text bold variant="h4">
            Charting is required
          </Text>

          <Text variant="body1" sx={{ textAlign: "center", textWrap: "balance" }}>
            {getMessage()}
          </Text>
        </Stack>
      </CardContent>
    </ShiftDetailsInnerCard>
  );
}
